module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/virtual_account_permata-82aafbd421bf46dad70e1167b6e6f820.svg";